import { IGNORE_ROUTES } from "@/constants/analitics.js";

const hasMetrika = () => {
  return window.hasOwnProperty('yaCounter93736397') && window.hasOwnProperty('ym')
};

const getCookie = (name) => {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) return value;
  }
};

const hasConsent = () => {
  try {
    return getCookie('my_cookie_consent') === 'true';
  } catch (e) {
    return false;
  }
};

export default ({ app, route, req, env }) => {
  if (process.server) {
    const referer = req.headers.referer;
    route.meta.referer = referer;
  } else {
    route.meta.referer = document.referrer;
  }

  if (process.client && app.__metrikaAfterEachRegistered) {
    return
  }

  if (process.client) {
    app.__metrikaAfterEachRegistered = true
  }

  app.router.afterEach((to) => {
    if (!IGNORE_ROUTES.includes(to.name)) {
      if (env.isStaging) return
      //app.$gtag('config', 'G-T8M239J0XR', {send_page_view: false})
      app.$gtag('event', 'page_view', { 'page_path': to.fullPath })
      try {
        if (hasConsent() && !hasMetrika() && window.ym && !window.__vistatYandexMetrikaInitialized) {
          window.__vistatYandexMetrikaInitialized = true
          ym(93736397, "init", { clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: true, defer: true });
        }
      } catch (e) {
        console.warn('Ошибка инициализации метрики:', e);
      }
    } else {
      try {
        if (hasMetrika()) {
          yaCounter93736397.destruct()
        }
      } catch (e) {
        console.warn('Ошибка при уничтожении метрики:', e);
      }
    }
  })
}
